/* eslint-disable array-callback-return */
/* eslint-disable no-unused-vars */
/* eslint-disable no-useless-concat */
/* eslint-disable eqeqeq */
/* eslint-disable no-redeclare */
/* eslint-disable no-use-before-define */
import Highcharts from 'highcharts/highstock';
import MomentTimeZone from 'moment-timezone';
import Moment from 'moment';
import authentication from './Authentication';
import { formatGraphTitle } from './HelperFunctions';

MomentTimeZone();
Moment();

window.moment = Moment;
require('highcharts/modules/accessibility');
require('highcharts/modules/draggable-points');
require('highcharts/modules/exporting');
require('highcharts/modules/export-data');
require('highcharts/modules/annotations');

var elexity = elexity || {};
elexity.gx = elexity.gx || {};

elexity.gx.trends = {
  // Properties
  entityKey: '',
  activeGraph: '',
  graphType: '',
  graphTitle: '',
  graphSubTitle: '',
  dateRange: [],
  campusTimeZone: '',

  // Chart instances
  charts: {},

  // Chart configurations
  chartConfigs: {
    utilityCharges: {
      url: '',
      divName: '',
      seriesDefinitions: [
        { name: 'Energy Cost', color: '#00DC92' },
        { name: 'Demand Cost', color: '#F96138' },
        { name: 'Tax Cost', color: '#004C93' },
        { name: 'Other Cost', color: '#FA974F' },
      ],
    },
    usageHistory: {
      url: '',
      divName: '',
      seriesDefinitions: [
        { name: 'Critical Peak', color: '#F96138' },
        { name: 'On Peak', color: '#00DC92' },
        { name: 'Mid Peak', color: '#FA974F' },
        { name: 'Off Peak', color: '#2FE0E6' },
        { name: 'Super Off Peak', color: '#004C93' },
      ],
    },
    peakDemand: {
      url: '',
      divName: '',
      seriesDefinitions: [{ name: 'Peak Demand', color: '#069BCE' }],
    },
    loadProfile: {
      url: '',
      divName: '',
      seriesDefinitions: [
        { name: 'Average Weekday', color: '#069BCE' },
        { name: 'Average Weekend', color: '#00DC92' },
        { name: 'Peak Day', color: '#FA974F' },
      ],
    },
  },

  // --- Helper Functions ---

  logAndLoad: async function (url, callback) {
    try {
      const response = await fetch(url, { headers: elexity.gx.trends.authToken });
      if (!response.ok) {
        if (response.status === 401) {
          authentication.logout();
          window.location.replace(authentication.logoutLink);
        }
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const text = await response.text();
      if (!text) {
        return null;
      }
      const jsonData = JSON.parse(text);
      elexity.gx.trends.campusTimeZone = jsonData.timeZoneCode;
      callback(jsonData);
    } catch (error) {
      console.error('Failed to fetch graph data:', error);
    }
  },

  buildDateString: function (ts, tz) {
    const format = new Intl.DateTimeFormat('en-GB', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      timeZone: tz,
    });
    return format.format(new Date(ts));
  },

  convertMinutesToTime: function (minutes) {
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    const formattedHours = String(hours).padStart(2, '0');
    const formattedMinutes = String(remainingMinutes).padStart(2, '0');
    return `${formattedHours}:${formattedMinutes}`;
  },

  // --- Core Functions ---

  initAuth: function (authToken) {
    elexity.gx.trends.authToken = authToken;
  },

  init: function (entityKey, url, divName, activeGraph, graphType, dateRange) {
    if (!entityKey) return;

    this.charts = {};

    elexity.gx.trends.entityKey = entityKey;
    elexity.gx.trends.activeGraph = activeGraph;
    elexity.gx.trends.graphType = graphType;
    elexity.gx.trends.dateRange = dateRange;
    elexity.gx.trends.graphTitle = `${formatGraphTitle(activeGraph)}`;

    const config = elexity.gx.trends.chartConfigs[activeGraph];
    if (config) {
      config.url = url.replaceAll('{entityKey}', entityKey);
      config.divName = divName;
      elexity.gx.trends.logAndLoad(
        config.url,
        elexity.gx.trends.initializeGraph.bind(elexity.gx.trends)
      );
    }
  },

  createBaseChartDefinition: function (type, yAxisTitle, plotOptions, tooltipFormatter) {
    return {
      title: { text: this.graphTitle },
      subtitle: { text: this.graphSubTitle },
      chart: {
        type: type,
        zooming: { mouseWheel: { enabled: false } },
        style: { fontFamily: 'Inter' },
      },
      rangeSelector: { enabled: false },
      navigator: { enabled: false },
      scrollbar: { enabled: false },
      credits: { enabled: false },
      legend: {
        enabled: true,
        itemStyle: { color: '#02222B', cursor: 'pointer', fontSize: '12px', fontWeight: '500' },
      },
      yAxis: [
        {
          lineWidth: 1,
          title: { text: yAxisTitle },
          opposite: false,
          labels: { style: { color: '#02222B' } },
        },
      ],
      xAxis: {
        title: { text: 'Date' },
        labels: {
          formatter: function () {
            return this.value;
          },
          rotation: -45,
          style: { color: '#02222B' },
        },
        type: 'category',
      },
      time: { timezone: elexity.gx.trends.campusTimeZone },
      plotOptions: plotOptions,
      series: elexity.gx.trends.chartConfigs[elexity.gx.trends.activeGraph].seriesDefinitions,
      tooltip: {
        shared: true,
        crosshairs: true,
        useHTML: true,
        borderWidth: 0,
        formatter: tooltipFormatter,
      },
    };
  },

  initializeGraph: function (graphData) {
    const config = elexity.gx.trends.chartConfigs[elexity.gx.trends.activeGraph];
    const divName = config.divName;
    const chartType = elexity.gx.trends.graphType;

    if (elexity.gx.trends.charts[divName]) {
      const currentChartType = elexity.gx.trends.charts[divName].options.chart.type;
      const newChartType = chartType === 'pie' ? 'pie' : 'column';

      if (currentChartType !== newChartType) {
        elexity.gx.trends.charts[divName].destroy();
        elexity.gx.trends.charts[divName] = null;
      }
    }

    if (!elexity.gx.trends.charts[divName]) {
      let chartDefinition;
      let plotOptions;
      let tooltipFormatter;

      switch (elexity.gx.trends.activeGraph) {
        case 'utilityCharges':
          if (chartType === 'pie') {
            chartDefinition = elexity.gx.trends.createBasePieDefinition();
          } else {
            plotOptions = { series: { stacking: 'normal', marker: { enabled: false, radius: 3 } } };
            tooltipFormatter = function () {
              const dateString = this.points[0].series.xAxis.categories[this.x];
              let allZero = false;
              this.points.forEach((point) => {
                if (point.options.dataLabels && point.options.dataLabels.enabled === false) {
                  allZero = true;
                }
              });

              let s = `<table style="width: 200px; font-size: smaller;"><tr><th colspan="2">${dateString}</th></tr>`;
              this.points.forEach((point) => {
                if (point.y !== 0) {
                  s += `<tr><td style="color: #02222B">${point.series.name}</td><td style="text-align: right"><b>$${point.y
                    .toFixed(2)
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</b></td></tr>`;
                }
              });
              if (allZero) {
                return `<table style="width: 200px; font-size: smaller;"><tr><th colspan="2">${dateString}</th></tr><tr><td colspan="2" >This data has been flagged for <br/>review, contact Elexity for details</td></tr></table>`;
              }
              return s;
            };
            chartDefinition = elexity.gx.trends.createBaseChartDefinition(
              'column',
              'Cost ($)',
              plotOptions,
              tooltipFormatter
            );
          }
          break;
        case 'usageHistory':
          if (chartType === 'pie') {
            chartDefinition = elexity.gx.trends.createBasePieDefinition();
          } else {
            plotOptions = { series: { stacking: 'normal', marker: { enabled: false, radius: 3 } } };
            tooltipFormatter = function () {
              const dateString = this.points[0].series.xAxis.categories[this.x];
              let allZero = false;
              this.points.forEach((point) => {
                if (point.options.dataLabels && point.options.dataLabels.enabled === false) {
                  allZero = true;
                }
              });

              let s = `<table style="width: 200px; font-size: smaller;"><tr><th colspan="2">${dateString}</th></tr>`;
              this.points.forEach((point) => {
                if (point.y !== 0) {
                  s += `<tr><td style="color: #02222B">${point.series.name}</td><td style="text-align: right"><b>${point.y
                    .toFixed(2)
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ',')} kWh</b></td></tr>`;
                }
              });
              if (allZero) {
                return `<table style="width: 200px; font-size: smaller;"><tr><th colspan="2">${dateString}</th></tr><tr><td colspan="2" >This data has been flagged for <br/>review, contact Elexity for details</td></tr></table>`;
              }
              return s;
            };
            chartDefinition = elexity.gx.trends.createBaseChartDefinition(
              'column',
              'kWh',
              plotOptions,
              tooltipFormatter
            );
          }
          break;
        case 'peakDemand':
          plotOptions = {
            series: {
              stacking: 'normal',
              marker: { enabled: false, radius: 3 },
              turboThreshold: 0,
            },
          };
          tooltipFormatter = function () {
            const dateString = this.points[0].series.xAxis.categories[this.x];
            let s = `<table style="width: 200px; font-size: smaller;"><tr><th colspan="2">${dateString}</th></tr>`;
            this.points.forEach((point) => {
              if (point.y !== 0) {
                s += `<tr><td style="color: #02222B">${point.series.name}</td><td style="text-align: right"><b>${point.y.toFixed(2)} kW</b></td></tr>`;
              }
            });
            return s;
          };
          chartDefinition = elexity.gx.trends.createBaseChartDefinition(
            'column',
            'kW',
            plotOptions,
            tooltipFormatter
          );
          break;
        case 'loadProfile':
          plotOptions = { series: { marker: { enabled: false, radius: 3 }, lineWidth: 3 } };
          tooltipFormatter = function () {
            const timeString = this.points[0].series.xAxis.categories[this.x];
            let s = `<table style="width: 200px; font-size: smaller;"><tr><th colspan="2">${timeString}</th></tr>`;
            this.points.forEach((point) => {
              if (point.y !== 0) {
                s += `<tr><td style="color: #02222B">${point.series.name}</td><td style="text-align: right"><b>${point.y.toFixed(2)} kWh</b></td></tr>`;
              }
            });
            return s;
          };
          chartDefinition = elexity.gx.trends.createBaseChartDefinition(
            'spline',
            'kW',
            plotOptions,
            tooltipFormatter
          );
          break;
        default:
          plotOptions = { series: { stacking: 'normal', marker: { enabled: false, radius: 3 } } };
          tooltipFormatter = function () {
            return '';
          };
          chartDefinition = elexity.gx.trends.createBaseChartDefinition(
            'column',
            '',
            plotOptions,
            tooltipFormatter
          );
          break;
      }

      elexity.gx.trends.charts[divName] = Highcharts.stockChart(divName, chartDefinition);
    }

    elexity.gx.trends.renderGraph(graphData);
  },

  createBasePieDefinition: function () {
    return {
      title: { text: this.graphTitle },
      subtitle: { text: this.graphSubTitle },
      chart: {
        type: 'pie',
        style: { fontFamily: 'Inter' },
      },
      legend: {
        enabled: true,
        itemStyle: { color: '#02222B' },
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: [
            {
              enabled: true,
              distance: 20,
            },
          ],
          showInLegend: true,
        },
      },
      series: [
        {
          data: [],
        },
      ],
      tooltip: {
        headerFormat: '',
        pointFormat: '<b>{point.name}</b>: {point.percentage:.1f} %',
      },
      credits: { enabled: false },
      rangeSelector: { enabled: false },
      navigator: { enabled: false },
      scrollbar: { enabled: false },
    };
  },

  renderGraph: function (graphData) {
    const { activeGraph, graphType } = elexity.gx.trends;

    elexity.gx.trends.renderChart(graphData);

    const chart = elexity.gx.trends.charts[elexity.gx.trends.chartConfigs[activeGraph].divName];
    if (chart) {
      chart.redraw();
      chart.hideLoading();
    }
  },

  renderChart: function (graphData) {
    const { activeGraph, chartConfigs, charts } = elexity.gx.trends;
    const config = chartConfigs[activeGraph];
    const divName = config.divName;
    const chart = charts[divName];
    const chartType = chart?.options.chart.type;

    if (chartType === 'pie') {
      elexity.gx.trends.renderPieChart(graphData);
    } else {
      elexity.gx.trends.renderBarChart(graphData);
    }
  },

  renderBarChart: function (graphData) {
    const { activeGraph, chartConfigs, charts } = elexity.gx.trends;
    const config = chartConfigs[activeGraph];
    const divName = config.divName;
    const chart = charts[divName];

    let dataEntries = [];
    let categories = [];
    let seriesDataArrays = config.seriesDefinitions.map(() => []);

    if (
      activeGraph === 'loadProfile' &&
      graphData.seriesNames &&
      graphData.seriesNames.length >= 3
    ) {
      const thirdSeriesName = graphData.seriesNames[2];
      config.seriesDefinitions[2].name = thirdSeriesName;
    }

    let from, to;
    if (elexity.gx.trends.dateRange.length > 0) {
      from = elexity.gx.trends.dateRange[0];
      to = elexity.gx.trends.dateRange[1];
    }

    if (activeGraph === 'utilityCharges' || activeGraph === 'usageHistory') {
      if (graphData.energyBills) {
        if (typeof from === 'number' && typeof to === 'number') {
          dataEntries = graphData.energyBills.filter((entry) => {
            const entryTime = new Date(entry.startDate).getTime();
            return entryTime >= from && entryTime <= to;
          });
        } else {
          console.error('Invalid date range values. Cannot filter data.');
        }
      }
    } else {
      dataEntries = graphData.entries;
    }

    dataEntries.sort((a, b) => {
      let dateA, dateB;
      if (activeGraph === 'peakDemand' || activeGraph === 'loadProfile') {
        dateA = a.timestamp;
        dateB = b.timestamp;
      } else {
        dateA = a.startDate;
        dateB = b.startDate;
      }
      return new Date(dateA) - new Date(dateB);
    });

    const isNotVerifiedDataArray = [];

    dataEntries.forEach((entry) => {
      let category;
      if (activeGraph === 'peakDemand' || activeGraph === 'loadProfile') {
        category =
          activeGraph === 'peakDemand'
            ? elexity.gx.trends.buildDateString(entry.timestamp, elexity.gx.trends.campusTimeZone)
            : elexity.gx.trends.convertMinutesToTime(entry.minuteOfDay);
      } else {
        category = elexity.gx.trends.buildDateString(
          entry.startDate,
          elexity.gx.trends.campusTimeZone
        );
      }
      categories.push(category);
      const costCategoriesVerified = entry?.costCategoriesVerified || false;

      isNotVerifiedDataArray.push(
        (() => {
          if (!costCategoriesVerified) {
            if (activeGraph === 'utilityCharges') {
              return entry?.totalCost ? Math.ceil(entry.totalCost) : 0;
            } else if (activeGraph === 'usageHistory') {
              return entry?.energykWh ? Math.ceil(entry.energykWh) : 0;
            } else {
              return null;
            }
          }
          return null;
        })()
      );

      config.seriesDefinitions.forEach((seriesDef, seriesIndex) => {
        let yValue = 0;
        if (activeGraph === 'utilityCharges') {
          if (costCategoriesVerified) {
            const originalName = seriesDef.name.split(' ')[0].toUpperCase();

            if (entry.chargeTypeCosts && entry.chargeTypeCosts.hasOwnProperty(originalName)) {
              yValue = Math.ceil(entry.chargeTypeCosts[originalName]);
            }
          }
        } else if (activeGraph === 'usageHistory') {
          if (costCategoriesVerified) {
            const touKey = seriesDef.name.replaceAll(' ', '_').toUpperCase();
            if (
              entry.touPeaks &&
              entry.touPeaks.hasOwnProperty(touKey) &&
              entry.touPeaks[touKey].volumekWh !== undefined
            ) {
              yValue = entry.touPeaks[touKey].volumekWh;
            } else {
              yValue = 100;
            }
          }
        } else if (activeGraph === 'peakDemand' || activeGraph === 'loadProfile') {
          const mDataIndex = graphData.seriesNames.indexOf(seriesDef.name);
          yValue = mDataIndex > -1 ? entry.values[mDataIndex] : 0;
        }

        seriesDataArrays[seriesIndex].push(yValue);
      });
    });

    chart.update(
      {
        xAxis: { categories: categories },
        series: config.seriesDefinitions.map((seriesDef, index) => ({
          name: seriesDef.name,
          data: (() => {
            return seriesDataArrays[index];
          })(),
          type: activeGraph === 'loadProfile' ? 'spline' : 'column',
        })),
      },
      false
    );

    if (activeGraph === 'utilityCharges' || activeGraph === 'usageHistory') {
      elexity.gx.trends.updateNotVerifiedValueSeries(chart, isNotVerifiedDataArray);
    }
  },

  updateNotVerifiedValueSeries: function (chart, placeHolderDataArray) {
    chart.addSeries(
      {
        name: 'Under Review',
        className: 'placeholder-series',
        color: '#77acdb77',
        data: placeHolderDataArray.map((data) => {
          return {
            y: data,
            color: '#77acdb77',
            className: 'placeholder-series',
            enableMouseTracking: false,
            dataLabels: {
              enabled: false,
              useHTML: true,
              allowOverlap: true,
              style: {
                color: '#569ED511',
                fontSize: '10px',
                fontWeight: 'bold',
              },
              formatter: function () {
                return '<div class="placeholder-label">Under Review</div>';
              },
            },
          };
        }),
        showInLegend: true,
      },
      false
    );
  },

  renderPieChart: function (graphData) {
    const { activeGraph, chartConfigs, charts } = elexity.gx.trends;
    const config = chartConfigs[activeGraph];
    const divName = config.divName;
    const chart = charts[divName];
    const pieSeries = [];

    const from = elexity.gx.trends.dateRange[0];
    const to = elexity.gx.trends.dateRange[1];

    let filteredData = [];
    if (graphData.energyBills) {
      if (typeof from === 'number' && typeof to === 'number') {
        filteredData = graphData.energyBills.filter((entry) => {
          const entryTime = new Date(entry.startDate).getTime();
          return entryTime >= from && entryTime <= to;
        });
      } else {
        console.error('Invalid date range values. Cannot filter data for pie chart.');
      }
    }

    let totals = {};
    filteredData.forEach((entry) => {
      config.seriesDefinitions.forEach((seriesDef) => {
        let yValue = 0;
        if (activeGraph === 'utilityCharges') {
          const originalName = seriesDef.name.split(' ')[0].toUpperCase();
          if (entry.chargeTypeCosts && entry.chargeTypeCosts.hasOwnProperty(originalName)) {
            yValue = Math.ceil(entry.chargeTypeCosts[originalName]);
          }
        } else if (activeGraph === 'usageHistory') {
          const touKey = seriesDef.name.replaceAll(' ', '_').toUpperCase();
          if (
            entry.touPeaks &&
            entry.touPeaks.hasOwnProperty(touKey) &&
            entry.touPeaks[touKey].volumekWh !== undefined
          ) {
            yValue = entry.touPeaks[touKey].volumekWh;
          }
        }

        totals[seriesDef.name] = (totals[seriesDef.name] || 0) + yValue;
      });
    });

    const totalSum = Object.values(totals).reduce((sum, val) => sum + val, 0);

    if (totalSum > 0) {
      config.seriesDefinitions.forEach((seriesDef) => {
        const totalValue = totals[seriesDef.name] || 0;
        if (totalValue > 0) {
          pieSeries.push({
            name: seriesDef.name,
            y: (totalValue / totalSum) * 100,
            color: seriesDef.color,
          });
        }
      });
    }

    chart.series[0].setData(pieSeries, false);
  },
};

export { elexity };
